
var col_count = $('.col_count').data('count');
var x = setInterval(function() {
    var totalItems = $('.carousel-item').length / col_count;
    currentIndex = ($('div.active').index() + 1) / col_count;
    currentIndex = Math.ceil(currentIndex)
    $('.num').html('' + currentIndex + '/' + totalItems + '');
}, 100);

